<div mat-dialog-title class="flex! items-center pt-4! px-4! pb-0!">
  <span class="text-xl py-2" data-testid="claas-apps">{{ 'navbar.user_menu.claas_apps' | translate }}</span>
  <claas-icon-button
    class="ml-auto"
    mat-dialog-close
    data-testid="app-launcher-dialog-close"
    [icon]="{ iconId: '648548', namespace: 'cc', iconStyle: 'linear' }">
  </claas-icon-button>
</div>

<div mat-dialog-content class="p-0!">
  <app-app-launcher></app-app-launcher>
</div>
